module.exports = __webpack_public_path__ + "static/assets/af2812f60c9af34c3eff92b178886bd6.jpg";